// src/context/ErrorContext.tsx

import React, { createContext, useContext, useEffect, useState } from 'react';
import { getError } from '../helper/parseValidationError';

interface ErrorContextType {
  errorMessages: string[];
  setErrorMessages: (messages: string[]) => void;
}

const ErrorContext = createContext<ErrorContextType>({
    errorMessages: [],
    setErrorMessages: () => {},
  });
  
export const ErrorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  //const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const [errorMessages, setErrorMessagesState] = useState<string[]>([]);

  // Load from localStorage on mount
  useEffect(() => {
    const storedErrors = getError();
    if (storedErrors) {
      try {
        setErrorMessagesState(storedErrors);
      } catch (e) {
        console.error("Failed to parse error messages from localStorage", e);
      }
    }
  }, []);

  const setErrorMessages = (messages: string[]) => {
    setErrorMessagesState(messages);
    localStorage.setItem("appErrorMessages", JSON.stringify(messages));
  };

  
  return (
    <ErrorContext.Provider value={{ errorMessages, setErrorMessages }}>
      {children}
    </ErrorContext.Provider>
  );
};


export const useError = (): ErrorContextType => {
    return useContext(ErrorContext);
  };

// export const useError = (): ErrorContextType => {
//   const context = useContext(ErrorContext);
//   if (!context) {
//     throw new Error("useError must be used within an ErrorProvider");
//   }
//   return context;
// };
